import { InlineImage } from "../../components/InlineImage";

/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
function T1750E1900() {
  return (
    <div>
      <div className="box light">
        <div className="row">
          <h1>Neerbosch tussen 1750 en 1900</h1>

          <h4>Neerbosch</h4>
          <InlineImage image="neerbosch/neerbosch_1822.jpg" width={400} subscript="Neerbosch in 1822" />
          <p>
            Het kaartje rechts uit 1822 is een stuk gedetailleerder dan oudere kaarten en geeft daarom een beter beeld van de exacte bebouwing in Neerbosch. Aan de Dorpstraat zijn
            nu de Bloemberg, Takenhof, Hazelarenbosch, Bykerk, Schoolhuis, Pastory, Boschlucht, Overkerk, Deb Dam en Hoogerhuizen opgetekend. De meeste zijn gewoon boerderijen of
            zoals het vroeger heette, een "bouwhof". Dat geldt voor de Bloemberg, Takenhof (jedoch is daar het huidige Takenhofplein naar vernoemd) en Hazelarenbosch. Ten zuiden
            van de Dorpsstraat liggen het Honightje en de Leuvensch hof, beide boerderijen. Aan de Dennenstraat liggen Den Berg, De Rooms Katholieke Kerk, De Witte Poort, de
            Pellekamp, de Vyverberg en Leeuwenstein.
          </p>
        </div>
      </div>
      <div className="box main">
        <div className="left">
          <h4>De Dam</h4>
          <p>
            De dam was een bouwhoeve aan de Dorpstraat te Neerbosch tegenover 't Slotje. De in 1649 gebouwde boerderij werd omstreeks 1930 gesloopt. Toen deze werd bewoond door de
            landbouwer Schamp, werd hij ook wel Schampendam genoemd. Zij droeg ook nog de naam Vredesheim.
          </p>
        </div>
        <div className="right">
          <h4>Boschwijk/Vijverberg</h4>
          <p>
            Boschwijk was een voormalig buitenverblijf tegenover Leeuwenstein aan den Lindenhoutscheweg. In 1889 werden de laatste overblijfselen van het gebouw afgebroken en door
            een boerderij vervangen. Het landgoed was geruime tijd in het bezit van de oude Nijmeegsche regeringsfamilie Pieck en werd daarom ook wel 'Pieckerbosch' genoemd. Tot
            Boschwijk behoorde vroeger ook de Vijverberg.
          </p>
        </div>
      </div>
      <div className="box light">
        <div className="left">
          <h4>Boschlucht/Boschlust</h4>
          <p>
            Villa Boschlucht, later Boschlust, was een buitengoed vlakbij de kerk. Een bron uit 1756 meldt dat het goed behalve een landhuis bestond uit plantages, twee boomgaarden
            en een sterrenbos. Rond 1830 kreeg het landhuis een tuin in Engelse landschapsstijl. Nadien werden verschillende bouwwerken aan het goed toegevoegd, zoals een
            koetshuis, een tuinmans- en koetsierswoning en een oranjerie. Nadat Boschlust in 1946 was gekocht door E.W. Smit werd het landhuis grondig verbouwd en uitgebreid. In de
            jaren '60 raakte het landgoed geheel ingeklemd tussen de nieuwbouw van Neerbosch-Oost en het bos van het naburige landgoed. In juni 1989 werd villa Boschlust gesloopt.
            Ter plaatse van het vroegere landgoed verrees een woonwijkje, nu ligt daar de Pskovlaan.
          </p>
        </div>
        <div className="right">
          <h4>Hoogerhuizen</h4>
          <p>
            Op de kaart uit 1822 staat Hoogerhuizen opgetekend als huis, stal en erf aan de Dorpsstraat. Van de vroegste eigenaars van dit landgoed is alleen bekend dat de heer
            H.P.G. Quack, gehuwd met freule von Carnap, dit bezat in 1838. Toen verkocht hij het landgoed namelijk. Het oorspronkelijke huis Hoogerhuizen moet enigszins somber van
            aanzien geweest zijn, waardoor het in de wandeling bekend stond als het Slotje. Later werd op diezelfde plaats een prachtig buitenhuis gebouwd door de notaris jonkheer
            Eugène van Rijckevorsel van Kessel wat er nu nog steeds staat (aan de Neerboscheweg). Vandaar dat dit buitenhuis de bijnaam "het slotje van de Baron" kreeg.
          </p>
        </div>
      </div>
      <div className="box main">
        <div className="left">
          <h4>St Antonius Abtkerk</h4>
          <InlineImage image="neerbosch/antonius_abtkerk.jpg" width={200} subscript="Antonius Abtkerk aan de Dennenstraat" />
          <p>
            In 1878 wordt de oude parochiekerk afgebroken omdat deze vervallen is geraakt. Hij maakt plaats voor een nieuwe kerk naar het ontwerp van P.J.H. Cuypers, die plaats
            bood aan ongeveer 600 personen. Gereedgekomen in 1880, werd de kerk op 7 juni van dat jaar door de toenmalige bisschop van 's-Hertogenbosch, mgr. A. Godschalk ingewijd.
          </p>
        </div>
        <div className="right">
          <h4>Het Spijker</h4>
          <p>
            Op de plaats waar vroeger slot Duvesteyn stond staat nu het Spijker, in de volksmond 't Spiek' genoemd. Andere noemen dit historisch boerderijcomplex 'Spijkerhof' wat
            onder meer bestond uit een grote T-boerderij, een Vlaamse schuur en een spieker, gelegen op een ruim erf met diverse groenelementen. De T-boerderij is in zijn huidige
            vorm ontstaan in 1866. De boerderij, nu aan de Nederheidseweg 198, is een gemeentelijk monument; de 'spijker', een vierkante stenen kamer op spijker met rieten
            schilddak, waarvan het muurwerk uit de 16e eeuw dateert. "spijker" betekende oorspronkelijk namelijk ook schuur en is afgeleid van het Latijnse 'spicarium', plaats waar
            'spicae' (korenaren) werden bewaard. Niet elke graan- of bergplaats werd als 'spieker' aangeduid, want aanvankelijk werden hier voornamelijk gebouwen mee bedoeld, waar
            de in natura betaalde pachten en de tienden werden aangebracht en opgeslagen ten behoeve van de veraf wonende grondbezitter. Soms groeiden dergelijke bergplaatsen uit
            tot buitenplaatsen, die dan ook wel 'spijker' worden genoemd.
          </p>
        </div>
      </div>
      <div className="box light">
        <div className="left">
          <h4>Spijkerburg/spijkerhof</h4>
          <p>
            Van de aan de dorpsstraat gelegen Spijkerhof wordt verondersteld dat dit perceel deel uitgemaakt zou hebben van het landgoed "het Spijker" of "Spijkerhof" gelegen aan
            de Nieuwstadweg in de wijk Lindenholt. Spijkerburg was van ongeveer 1790 tot 1915 in het bezit van de familie Kellendonk. Het zou goed kunnen dat het huis ouder blijkt
            te zijn dan het exterieur ons in eerste instantie doet voorkomen. Het pand stond vroeger ook bekend als "De Tempel". Waar die verwijzing op slaat is onbekend.
          </p>
          <p>
            De bewoners vertellen het volgende: Het huis is zeer oud, hoe oud is niet bekend. De naam "De Tempel" wordt nog steeds gebruikt. De herkomst van deze naam is eveneens
            niet bekend. Als bouwmateriaal komen opvallend grote bakstenen (kloostermoppen?) voor. Er was een oude put, gebouwd met typische putstenen. Deze put is nu dichtgegooid.
            Vroeger waren er in het huis muurschilderingen. Het was niet duidelijk wat ze voorstelden. Ze waren niet mooi meer. Daarom waren er tegeltjes overheen gezet. Rond het
            huis werden herhaaldelijk munten - "provincie-geld"- gevonden.
          </p>
          <p>
            Opvallend is dat op de kadastrale kaart uit 1822 het gebouw wel getekend is maar geen naamsvermelding heeft gekregen. Over het ontstaan van de naam "De Tempel" gaan
            diverse geruchten. Zo zouden er banden zijn met de Tempeliers en zou dit wellicht het bezit geweest zijn van de abdij van Gravendaal. Zij waren immers 1 van de kopers
            bij de ontginning van 1300, maar op geen enkele kaart is iets van hun bezit terug te vinden.
          </p>
        </div>
        <div className="right">
          <InlineImage image="neerbosch/spijkerhof.jpg" subscript="Spijkerhof aan de Dorpsstraat" />
        </div>
      </div>
      <div className="box main">
        <div className="left">
          <h4>De Rosa stichting</h4>
          <p>
            In 1848 liet de pastoor van Neerbosch, Dominicus van Zeeland, vijf Rotterdamse dominicanessen naar zijn dorp overkomen om daar onderwijs te geven aan katholieke
            meisjes. In een als school dienstdoend woonhuis gaven de zusters naai- en breiles. In 1851 betrokken de zusters dominicanessen een groot en nieuw klooster aan de
            Dennenstraat, waar zij een kleuterschool, een lagere school, een huishoudschool en een kweekschool inrichtten. Omdat in het begin van de vorige eeuw ook dit gebouw te
            klein bleek, werd in 1911-1912 direct ernaast een groot, nieuw gebouw opgetrokken. In dit nieuwe hoofdgebouw van het klooster, dat vanaf 1911 bekend werd als de
            Rosastichting, werden de scholen en een pensionaat gevestigd. In het oude kloostergebouw versleten de oude zusters hun laatste dagen. Eind jaren '80 kwam er een einde
            aan het onderwijs door de zusters en in 1989 werd het hoofdgebouw van de Rosastichting afgebroken. Het oude, neoclassicistische kloostergebouw uit 1850-1851 bleef
            behouden en is nog steeds van de stichting.
          </p>
        </div>
        <div className="right">
          <h4>Het Franse beleg</h4>
          <p>
            In 1794 vallen de Fransen Nederland binnen en ook Nijmegen wordt belegerd. De Fransen stelden enkele bataljons op in Hees en Neerbosch, waaronder in het landgoed
            Hogerhuyzen zoals op een kaart uit 1794 van die belegering te zien is. Van die Franse belegering resten nog enkele kanonskogels die ondermeer in de muur van Looimolen
            aan de Graafse weg nog altijd te zien zijn.
          </p>
        </div>
      </div>
    </div>
  );
}

export default T1750E1900;
